module.exports = __webpack_public_path__ + "img/9635f05.jpg";